import React, { useState, useEffect, useContext } from "react";
import { LangContext } from "../../contexts/LangContext";
import en from "../../i18n/en";
import pl from "../../i18n/pl";
import ScrapingForm from "./ScrapingForm";
import FilteringForm from "./FilteringForm";
import ScrapingFilteringForm from "./ScrapingFilteringForm";
import templateData from "../../templates/templateData";
import "../../styles/CreateTask.css";
import { useLocation } from "react-router-dom";


const STORAGE_KEYS = {
  TASK_NAME: "create_task_name",
  TASK_TYPE: "create_task_type",
  SCRAPING_DATA: "create_scraping_data",
  FILTERING_DATA: "create_filtering_data",
};

const TASK_TYPES = [
  { key: "scraping", nameKey: "scrapingLabel", descKey: "scrapingDesc" },
  { key: "filtering", nameKey: "filteringLabel", descKey: "filteringDesc" },
  { key: "scraping+filtering", nameKey: "scrapingFilteringLabel", descKey: "scrapingFilteringDesc" },
];

export function CreateTaskPage({userInfo, onSave, onCancel, onTestPrompt, initialTemplateId }) {

  const ADMIN_IDS = [13]
  const IS_ADMIN = ADMIN_IDS.includes(userInfo.id)


  const { lang } = useContext(LangContext);
  const t = lang === "pl" ? pl : en;

  const [taskName, setTaskName] = useState("");
  const [taskType, setTaskType] = useState("scraping");
  const [prefillData, setPrefillData] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false);

  // ДОБАВЬ В ИМПОРТ:


// ВНУТРИ КОМПОНЕНТА ДОБАВЬ:
const location = useLocation();

// НАЙДИ useEffect инициализации, замени его содержимое:
useEffect(() => {
  if (isInitialized) return;

  let name = "";
  let type = "scraping";
  let prefill = null;

  // === ДУБЛИРОВАНИЕ ===
const duplicatedTask = location.state?.prefillTask;
if (duplicatedTask) {
  const dTaskType = duplicatedTask.task_type || "scraping";
  name = `${duplicatedTask.task_name || ""} (Copy)`;
  type = (dTaskType === "scraping_and_filtering" || dTaskType === "scraping_filtering")
    ? "scraping+filtering"
    : dTaskType;

  const subtype = duplicatedTask.search_config?.subtype || "";
  let selectedSocial = "";
  if (subtype.startsWith("instagram")) selectedSocial = "instagram";
  else if (subtype.startsWith("facebook")) selectedSocial = "facebook";
  else if (subtype.startsWith("linkedin")) selectedSocial = "linkedin";

  const keywordsArr = duplicatedTask.keywords?.map(k => typeof k === "string" ? k : k.keyword) || [];

  // ---- FILTERING PREFILL ----
  const fc = duplicatedTask.filtering_config || null;
  let filteringPrefill = null;

  if (fc) {
    const rawRules = fc.filters?.rules || {};
    const rulesArr = Object.entries(rawRules).map(([field, rule]) => {
      const operator = rule.op || rule.operator;
      const base = {
        id: `${field}_${Date.now()}_${Math.random().toString(36).slice(2)}`,
        field,
        operator,
      };
      if (operator === "between" && Array.isArray(rule.value)) {
        base.valueMin = rule.value[0];
        base.valueMax = rule.value[1];
      } else if (!["is_not_empty", "is_true", "is_false"].includes(operator)) {
        base.value = rule.value;
      }
      return base;
    });

    const reelsRaw = fc.filters?.reels_config || {};
    const metrics = reelsRaw.metrics_filter || {};
    const hasMetrics = Object.values(metrics).some(v => v !== null && v !== undefined);

    filteringPrefill = {
      // КЛЮЧЕВОЕ: без этого форма не покажет ни правила, ни билдер
      selectedTask: String(
        fc.target_task_id ?? duplicatedTask.additional_info?.target_task_id ?? ""
      ),
      rules: rulesArr, // массив, не объект
      matchType: fc.filters?.match_type || "all",
      useAI: !!fc.use_ai,
      aiPrompt: fc.ai_prompt || "",
      aiMiddlePart: reelsRaw.ai_filter_prompt || "",
      matchWord: fc.ai_pass_keyword || reelsRaw.ai_pass_keyword || "",
      matchScope: fc.check_only_on_first_row ? "first_line" : "full_text",
      _aiPromptInitialized: true,
      reelsMetrics: {
        enabled: hasMetrics,
        minViews: metrics.min_views ?? "",
        maxViews: metrics.max_views ?? "",
        minLikes: metrics.min_likes ?? "",
        maxLikes: metrics.max_likes ?? "",
        minComments: metrics.min_comments ?? "",
        maxComments: metrics.max_comments ?? "",
        minEngagementRate: metrics.min_engagement_rate ?? "",
        maxEngagementRate: metrics.max_engagement_rate ?? "",
        engagementFormula: reelsRaw.engagement_formula || "standard",
        topReelsCount: reelsRaw.top_reels_count || 30,
        sortBy: reelsRaw.sort_by || "engagement",
        needFilter: reelsRaw.need_filter || false,
        needDescription: reelsRaw.need_description || false,
        generateSummary: reelsRaw.generate_summary || false,
        summaryPrompt: reelsRaw.summary_prompt || "",
        _summaryPromptInitialized: !!reelsRaw.summary_prompt,
        filterMethods: [], // восстановить нельзя без доп. поля на бэке
      },
    };
  }

  prefill = {
    scraping: {
      keywords: keywordsArr.join("\n"),
      selectedSocial,
      selectedPlatform: subtype,
      advancedSettings: {
        searchLanguage: duplicatedTask.search_config?.search_language || "en",
        scrapingPeriods: duplicatedTask.search_config?.search_periods || ["any"],
        maxPages: duplicatedTask.search_config?.max_pages_per_query || 5,
      },
      parseAuthorPages:
        duplicatedTask.additional_info?.instagram_posts_included === "True" ||
        duplicatedTask.additional_info?.instagram_posts_included === true,
    },
    filtering: filteringPrefill,
  };

  sessionStorage.setItem(STORAGE_KEYS.TASK_NAME, name);
  sessionStorage.setItem(STORAGE_KEYS.TASK_TYPE, type);
  sessionStorage.setItem(STORAGE_KEYS.SCRAPING_DATA, JSON.stringify(prefill.scraping));
  if (prefill.filtering) sessionStorage.setItem(STORAGE_KEYS.FILTERING_DATA, JSON.stringify(prefill.filtering));

  window.history.replaceState({}, document.title);
}
  
  // === ШАБЛОНЫ ===
  else if (initialTemplateId && templateData[initialTemplateId]) {
    const tpl = templateData[initialTemplateId];
    const tplPrefill = tpl.prefill;
    name = tplPrefill.taskName?.[lang] || tplPrefill.taskName?.en || "";
    type = tplPrefill.taskType || "scraping";
    prefill = {
      scraping: tplPrefill.scraping || null,
      filtering: tplPrefill.filtering || null,
    };

    if (tplPrefill.scraping) {
      sessionStorage.setItem(STORAGE_KEYS.SCRAPING_DATA, JSON.stringify(tplPrefill.scraping));
    }
    if (tplPrefill.filtering) {
      sessionStorage.setItem(STORAGE_KEYS.FILTERING_DATA, JSON.stringify(tplPrefill.filtering));
    }
  }
  // === SESSION STORAGE ===
  else {
    name = sessionStorage.getItem(STORAGE_KEYS.TASK_NAME) || "";
    type = sessionStorage.getItem(STORAGE_KEYS.TASK_TYPE) || "scraping";
  }

  setTaskName(name);
  setTaskType(type);
  setPrefillData(prefill);
  setIsInitialized(true);
}, [initialTemplateId, lang, isInitialized, location.state]);

  // === Persist ===
  useEffect(() => { sessionStorage.setItem(STORAGE_KEYS.TASK_NAME, taskName); }, [taskName]);
  useEffect(() => { sessionStorage.setItem(STORAGE_KEYS.TASK_TYPE, taskType); }, [taskType]);

  // === Handlers ===
  const clearAll = () => {
    if (window.confirm(t.clearAllConfirm)) {
      setTaskName("");
      setTaskType("scraping");
      setPrefillData(null);
      Object.values(STORAGE_KEYS).forEach(key => sessionStorage.removeItem(key));
      window.dispatchEvent(new Event("clearAllTasks"));
    }
  };

  const handleSave = async (data) => {
    await onSave(data);
  };

  const handleTaskTypeChange = (newType) => {
    setTaskType(newType);
    setPrefillData(null);
    if (newType === "scraping") {
      sessionStorage.removeItem(STORAGE_KEYS.FILTERING_DATA);
    } else if (newType === "filtering") {
      sessionStorage.removeItem(STORAGE_KEYS.SCRAPING_DATA);
    }
  };

  // === Loading ===
  if (!isInitialized) {
    return (
      <div className="add-rule-wrap">
        <div className="spinner-page">
          <div className="spinner" />
        </div>
      </div>
    );
  }

  // === Render ===
  return (
    <div className="add-rule-wrap create-task-wrap">
      {/* Header */}
      <div className="create-task-header">
        <div>
          <h2 className="create-task-title">{t.createTaskPage.newTaskTitle}</h2>
          <p className="create-task-desc">{t.createTaskPage.tasksDesc}</p>
        </div>
        <button className="btn-clear-all" onClick={clearAll}>
          🗑️ {t.createTaskPage.clearAll}
        </button>
      </div>

      {/* Task Type */}
      <div className="section-card">
        <h3>{t.createTaskPage.taskType}</h3>
        <div className="task-type-grid">
          {TASK_TYPES.map(({ key, nameKey, descKey }) => (
            <button
              key={key}
              className={`task-type-btn${taskType === key ? " active" : ""}`}
              onClick={() => handleTaskTypeChange(key)}
            >
              <div className="task-type-btn-name">{t['createTaskPage'][nameKey]}</div>
              <div className="task-type-btn-desc">{t['createTaskPage'][descKey]}</div>
            </button>
          ))}
        </div>
      </div>

      {/* Task Name */}
      <div className="section-card">
        <h3>{t.createTaskPage.taskName}<span className="required-badge" >*</span></h3>

        <input
          className="form-input"
          type="text"
          placeholder={t.createTaskPage.taskNamePlaceholder}
          value={taskName}
          onChange={(e) => setTaskName(e.target.value)}
        />
      </div>

      {/* Forms */}
      {taskType === "scraping" && (
        <ScrapingForm
          IS_ADMIN={IS_ADMIN}
          onSave={handleSave}
          onCancel={onCancel}
          taskName={taskName}
          prefillData={prefillData?.scraping}
        />
      )}

      {taskType === "filtering" && (
        <FilteringForm
          IS_ADMIN={IS_ADMIN}
          onSave={handleSave}
          onCancel={onCancel}
          taskName={taskName}
          onTestPrompt={onTestPrompt}
          prefillData={prefillData?.filtering}
        />
      )}

      {taskType === "scraping+filtering" && (
        <ScrapingFilteringForm
          IS_ADMIN={IS_ADMIN}
          taskName={taskName}
          onSave={handleSave}
          onCancel={onCancel}
          prefillData={prefillData}
        />
      )}
    </div>
  );
}